__turbopack_context__.v({
  "campaignDescription": "OfferModal-module__L-JlYq__campaignDescription",
  "campaignHeader": "OfferModal-module__L-JlYq__campaignHeader",
  "campaignLayoutPadding": "OfferModal-module__L-JlYq__campaignLayoutPadding",
  "campaignLayoutWrapper": "OfferModal-module__L-JlYq__campaignLayoutWrapper",
  "campaignOffer": "OfferModal-module__L-JlYq__campaignOffer",
  "campaignSelectorWrapper": "OfferModal-module__L-JlYq__campaignSelectorWrapper",
  "campaignTitle": "OfferModal-module__L-JlYq__campaignTitle",
  "championshipWhite": "OfferModal-module__L-JlYq__championshipWhite",
  "layoutBody": "OfferModal-module__L-JlYq__layoutBody",
  "layoutText": "OfferModal-module__L-JlYq__layoutText",
  "layoutTextMobile": "OfferModal-module__L-JlYq__layoutTextMobile",
  "mint": "OfferModal-module__L-JlYq__mint",
  "modalBody": "OfferModal-module__L-JlYq__modalBody",
  "modalContainer": "OfferModal-module__L-JlYq__modalContainer",
  "mustangYellow": "OfferModal-module__L-JlYq__mustangYellow",
  "oldFerrariRed": "OfferModal-module__L-JlYq__oldFerrariRed",
  "sunbeamBlue": "OfferModal-module__L-JlYq__sunbeamBlue",
});
